var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "div-block-25"
  }, [_vm.coApplicantLoadingGetter ? _c('v-progress-circular', {
    staticClass: "loading-spinner small",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "add-prijem-btn",
    attrs: {
      "data-w-id": "4c06adb2-2b97-ce79-91ef-5e3b3e797c81"
    }
  }, [_c('div', {
    staticClass: "text-small bl-color pointer",
    on: {
      "click": function click($event) {
        return _vm.openPropertyTypePicker();
      }
    }
  }, [_vm._v(" + pridať SPOLUŽIADATEĽA ")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }